export default "__VITE_ASSET__N2qbfrT3__$_?imageSize__"